export enum PERSISTED_STATE_STORAGE_KEYS {
    SITE_STATE = 'roompulse.site.state',
    COMPANY_HOTEL_SELECTOR_STATE = 'roompulse.company_hotel_selector.state',
    DASHBOARD_STATE = 'roompulse.dashboard.state',
}

const useWebStorage = () => {
    const setItem = <T>(name: string, value: T): void => {
        return localStorage.setItem(name, JSON.stringify(value));
    }

    const getItem = <T>(name: string): T | null => {
        const val = localStorage.getItem(name);
        if (val == null) return null;
        return <T>JSON.parse(val);
    }

    const removeItem = (name: string) => {
        return localStorage.removeItem(name);
    }

    return {
        setItem: setItem,
        getItem: getItem,
        removeItem: removeItem
    }
}

export default useWebStorage;
